import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  accessToken: '',
  filterParams: [],
  areChipsHidden: false,
  isAuthTokenValidated: false,
  password: '',
  displayParams: [],
}

export const stakeholderDashboardDetails = createSlice({
  name: 'stakeholderDashboard',
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<any>) {
      state.accessToken = action.payload
    },
    setFilterParams(state, action: PayloadAction<any>) {
      state.filterParams = action.payload
    },
    setValidAuthToken(state, action: PayloadAction<any>) {
      state.isAuthTokenValidated = action.payload
    },
    setPassword(state, action: PayloadAction<any>) {
      state.password = action.payload
    },
    setChipsVisibility(state, action: PayloadAction<any>) {
      state.areChipsHidden = action.payload
    },
    setDisplayParams(state, action: PayloadAction<any>) {
      state.displayParams = action.payload
    },
  },
})

export const {
  setAccessToken,
  setFilterParams,
  setValidAuthToken,
  setPassword,
  setChipsVisibility,
  setDisplayParams,
} = stakeholderDashboardDetails.actions
export default stakeholderDashboardDetails.reducer
